/* eslint-disable */
export default {
  matched: 'Overeenkomend',
  other: 'Overig',
  associated: 'Gekoppeld',
  foundFromServer: 'Resultaten uit {appName}',
  recently: 'Recent',
  additionalLabelAccount: 'Account: {displayName}',
  additionalLabelContact: 'Contact: {displayName}',
  notFound: 'Niet beschikbaar',
} as const;

// @key: @#@"matched"@#@ @source: @#@"Matched"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"associated"@#@ @source: @#@"Associated"@#@
// @key: @#@"foundFromServer"@#@ @source: @#@"Found from {appName}"@#@
// @key: @#@"recently"@#@ @source: @#@"Recent"@#@
// @key: @#@"additionalLabelAccount"@#@ @source: @#@"Account: {displayName}"@#@
// @key: @#@"additionalLabelContact"@#@ @source: @#@"Contact: {displayName}"@#@
// @key: @#@"notFound"@#@ @source: @#@"N/A"@#@
